import ReactGA from "react-ga4";

const measurementId = "G-JLMSBM962M"; // Replace with your actual Measurement ID

export const initGA = () => {
  ReactGA.initialize(measurementId);
};

export const logPageView = () => {
  ReactGA.send("pageview");
};
